import React from 'react';

export default function Loading({ message = 'Loading...' }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '200px',
      gap: '1rem'
    }}>
      <div className="spinner"></div>
      <p style={{ color: '#666', fontSize: '14px' }}>{message}</p>
    </div>
  );
}
